export default {
    SET_RECHERCHELISTS (state, rechercheLists) {
      state.rechercheLists = rechercheLists
    },
    SET_ADDRESSLISTS (state, addresslist) {
      state.addresslist = addresslist
    },
    SET_AMBASSADORSLIST (state, ambassadorslist) {
      state.ambassadorslist = ambassadorslist
    },
    SET_EVALUATIONS (state, evaluations) {
      state.evaluations = evaluations
    },
    SET_MEILISEARCHCONTENT (state, meilisearchContent) {
      state.meilisearchContent = meilisearchContent
    },
    SET_SEARCHPARAM_MS (state, searchParamMeiliSearch) {
      state.searchParamMeiliSearch = searchParamMeiliSearch
    },
    SET_TOTALCOUNT_MS (state, totalCountMeiliSearch) {
      state.totalCountMeiliSearch = totalCountMeiliSearch
    },
    SET_COMPLETE_CUSTOM_FILTER (state, completeCustomFilter) {
      state.completeCustomFilter = completeCustomFilter
    },
    SET_SAVE_LIST_STATUS (state, saveListStatus) {
      state.saveListStatus = saveListStatus
    },
    SET_SAVE_LIST_MAX_LIMIT (state, saveListMaxLimit) {
      state.saveListMaxLimit = saveListMaxLimit
    },
    SET_LAST_ADDED_POOLDATA (state, lastAddedList) {
      state.lastAddedList = lastAddedList
    },
    SET_POOL_LIST (state, poolData) {
      state.poolData = poolData
    },
    SET_LAST_LIST_ADDED_STATUS (state, lastListAddedStatus) {
      state.lastListAddedStatus = lastListAddedStatus
    },
    SET_LAST_ADDED_ADDRESSES_STATUS (state, modalLastAddressesStatus) {
      state.modalLastAddressesStatus = modalLastAddressesStatus
    },
    SET_SAVE_QUERY_ALL_FILTERS (state, saveQueryAllFilters) {
      state.saveQueryAllFilters = saveQueryAllFilters
    },
    SET_SAVEDLISTS_NAMES (state, savedListsNames) {
      state.savedListsNames = savedListsNames
    },
    SET_SAVEDLISTS (state, savedLists) {
      state.savedLists = savedLists
    },
    SET_IMPORTEDSAVEDLISTES (state, importedSavedLists) {
      state.importedSavedLists = importedSavedLists
    }
  }
